export const rulesMessages = {
  referralCode: {
    referralCodeMin: 'Minimum 1 Characters Are Required',
    referralCodeMax: 'Maximum 15 Characters Are Allowed',
    referralCodeCharacters: 'Only Uppercase Alphabets And Numbers Are Allowed',
  },
};
